/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Availability_MismatchesInputs */

const en_nav_availability_mismatches = /** @type {(inputs: Nav_Availability_MismatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability mismatches`)
};

/**
* | output |
* | --- |
* | "Availability mismatches" |
*
* @param {Nav_Availability_MismatchesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_availability_mismatches = /** @type {((inputs?: Nav_Availability_MismatchesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Availability_MismatchesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_availability_mismatches(inputs)
});